// De laatste stand die het dashboard heeft laten zien, en wanneer dat was.
//
// De Raspberry Pi gaat 's avonds uit en 's ochtends weer aan. Het vergelijken
// van twee metingen (zie useSaleEvents) begint na een herstart pas bij de
// eerste meting, dus alles wat er 's nachts of in het weekend is verkocht zou
// stil op de kaarten verschijnen, zonder balk of confetti. Daarom bewaren we
// hier in de browser van de tv waar we waren: na het aanzetten weten we dan
// sinds wanneer het scherm uit stond en wat er sindsdien is bijgekomen.
//
// Elke meting overschrijft de vorige, dus de tijd erin is ook de laatste keer
// dat het scherm nog leefde - hoe laat de Pi uitging, op een minuut na.

const storageKey = "td-last-seen";

// scope: de maand ("9-2026"). Een stand van een andere maand is niets waard,
// want de teller begint elke maand op nul.
export function readLastSeen(scope) {
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return null;
    const record = JSON.parse(raw);
    if (record?.scope !== scope || typeof record.at !== "number") return null;
    return record;
  } catch (error) {
    // Privémodus of volle opslag: dan gaat het zonder inhalen.
    return null;
  }
}

export function writeLastSeen(record) {
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(record));
  } catch (error) {
    /* niets aan te doen, en het mag het dashboard niet ophouden */
  }
}

// Alleen de tijd bijstellen, de cijfers laten staan.
//
// De tv gaat uit terwijl de Pi doorloopt: dan is de laatste meting nog
// steeds de goede stand, maar klopt de tijd erbij niet meer. Die hoort het
// moment te zijn waarop het beeld wegviel, niet dat van de laatste
// ophaalronde - anders zegt de kaart "sinds 17:59" terwijl de tv om 18:04
// uitging. Zie utils/screenAwake.js.
export function touchLastSeen(scope, at) {
  const record = readLastSeen(scope);
  if (!record || typeof at !== "number") return;
  writeLastSeen({ ...record, at });
}
